import type { AgentAccessScope, AgentStoredMessage } from '@cdf/api-client-react';

export function agentWorkspaceScopeKey(scope: AgentAccessScope): string {
  return [scope.kind, scope.tenantId ?? '', scope.entityId ?? ''].join(':');
}

export function agentWorkspaceParams(scope: AgentAccessScope) {
  return { scopeKind: scope.kind, ...(scope.tenantId ? { tenantId: scope.tenantId } : {}),
    ...(scope.entityId ? { entityId: scope.entityId } : {}) };
}

export function workspaceError(error: unknown): string {
  return error instanceof Error ? error.message : 'Could not save this change. Your draft is retained.';
}

export function storedAgentTurns(rows: AgentStoredMessage[]) {
  return rows.flatMap((row, index) => [
    { id: row.id + ':user', requestId: row.clientRequestId, historical: true, role: 'user' as const, content: row.content },
    ...(row.response ? [{
      id: row.id + ':agent', requestId: row.clientRequestId, role: 'agent' as const, content: row.response.reply,
      tenderPreparationId: row.response.tenderPreparationId,
      webEvidence: row.response.webEvidence, sources: row.response.sources, draftHandoffs: row.response.draftHandoffs,
      proposals: row.response.proposals, continuations: row.response.continuations, historical: true, evidenceState: row.response.evidenceState,
      evidenceMessage: row.response.evidenceMessage, clarification: row.response.clarification,
      clarificationAnswered: rows.slice(index + 1).some(next => next.status === 'completed')
    }] : [{
      id: row.id + ':status', requestId: row.clientRequestId, historical: true, role: 'agent' as const,
      content: row.status === 'running' ? 'This send is still running. Refresh history to check its outcome.'
        : row.status === 'interrupted' ? 'This send was interrupted. It will not be resent automatically.'
        : 'This send failed. It will not be resent automatically.',
    }])
  ]);
}
